module.exports = "//public.zight.com/packs/media/images/social-proof-image-e8a14c40fc67b397a33d8b59a2d3771b.jpeg";